import {
  PLAN_IMPLEMENTATION_RESOURCE,
  MANAGE_ACTION
} from '@/constants/resources'


export default [
  {
    path: '/plano-implementacao/:id',
    name: 'plan-implementation',
    component: () => import('@/modules/plan_implementation/views/PlanImplementation.vue'),
    meta: {
      resource: PLAN_IMPLEMENTATION_RESOURCE,
      action: MANAGE_ACTION
    },
  }
]
